export const THEME_COLOR = "#7338FF";

export const RUSD_FEATURES = [
  "持续收益，稳定运行",
  "团队合作，共享收益",
  "基于协议的奖励分配",
];

export const PROMOTION_ITEMS = [
  {
    icon: require("@/assets/image/tglm.png"),
    title: "推广联盟",
    desc: "层级奖励，团队奖励，业绩奖励，卡牌奖励",
  },
  {
    icon: require("@/assets/image/nftds.png"),
    title: "NFT大使",
    desc: "绩效奖励，代币赠送，全网分红，多节点奖励",
  },
];

export const ROADMAP_ITEMS = [
  {
    date: "6月",
    title: "新加坡基金会重启RAD生态",
    desc: "半年内逐步将底池建设到1000万枚BOX以上",
  },
  {
    date: "6月",
    title: "开启Ai超级算法龙虾策略进行全球公测",
    desc: "通过后将获得风投基金1000-5000万美金战略支持",
  },
  {
    date: "7月",
    title: "第1批合伙人节点",
    desc: "(金卡、银卡、铜卡)拆盲盒抢购",
    titleHighlight: true,
  },
  {
    date: "7-8月",
    title: "上线RAD质押生态",
    desc: "",
  },
  {
    date: "9月",
    title: "完成底池500万枚BOX建设",
    desc: "",
  },
  {
    date: "12月",
    title: "完成底池1000万枚BOX建设",
    desc: "",
  },
  {
    date: "2027",
    quarter: "1季度",
    title: "上线稳定币DEFI生态",
    desc: "含第2批卡牌拆盲盒",
  },
  {
    date: "2027",
    quarter: "2季度",
    title: "上线中心化交易所",
    desc: "币安 欧意等",
  },
  {
    date: "2027",
    quarter: "3季度",
    title: "上线链上游戏生态",
    desc: "含第3批卡牌拆盲盒",
  },
  {
    date: "2027",
    quarter: "4季度",
    title: "上线链上商城生态",
    desc: "含第4批卡牌拆盲盒",
  },
  {
    date: "2028-2030",
    title: "币股同权在美国纳斯达克上市",
    desc: "",
    // future: true,
  },
];

export const PARTNERS_LIST = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  image: require(`@/assets/image/partner${i + 1}.png`),
}));
